export const styles = {
  header: (theme) => ({
    backgroundColor: 'kit.background.white',
    position: 'sticky',
    top: 0,
    zIndex: 5,
    width: '100%',
    filter: 'drop-shadow(0px 4px 8px rgba(103, 102, 131, 0.12))',
  }),
};
